module.exports = "<div id=\"test\">\n  <div id=\"main\">\n    <app-header></app-header>\n\n    <router-outlet></router-outlet>\n\n  </div>\n</div>\n\n<footer id=\"footer\">\n  <app-footer></app-footer>\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main